// ----------------------------------------------------------------------
// Server-Sent Events over fetch. `EventSource` can't send an Authorization header or a
// POST body, so authenticated streams (Ask AI, #405) read `res.body` and parse frames here.
// ----------------------------------------------------------------------

/**
 * An incremental SSE parser: feed it decoded chunks, it calls `onEvent` with the parsed
 * JSON of every complete `data:` frame (comment / heartbeat lines are ignored). Frames may
 * be split across chunks; call `flush()` at the end for a final frame without a trailing
 * blank line. A frame whose data isn't JSON is dropped.
 */
export function createSseParser<T>(onEvent: (event: T) => void): { push: (chunk: string) => void; flush: () => void } {
  let buffer = '';
  const emit = (frame: string) => {
    const data = frame
      .split('\n')
      .filter((line) => line.startsWith('data:'))
      .map((line) => line.slice(5).replace(/^ /, ''))
      .join('\n');
    if (!data) return;
    try {
      onEvent(JSON.parse(data) as T);
    } catch {
      // malformed frame — skipped
    }
  };
  return {
    push(chunk) {
      buffer += chunk.replace(/\r\n/g, '\n');
      let at = buffer.indexOf('\n\n');
      while (at >= 0) {
        emit(buffer.slice(0, at));
        buffer = buffer.slice(at + 2);
        at = buffer.indexOf('\n\n');
      }
    },
    flush() {
      if (buffer.trim()) emit(buffer);
      buffer = '';
    },
  };
}
